import isObject from './isObject.js';

/**
 * Check if object is empty
 * @param {object} value Object to check
 * @returns {boolean}
 */
export default (value) => {
	return !isObject(value) || isObject(value) && Object.keys(value).length === 0;
};
